/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import InputField from "../../components/Layout/InputField";
import Button from "../../components/Layout/Button";
// import DataTable from "../../components/Layout/Table/DataTable";
import TableData from "../../components/Layout/Table/TableData";
import {
  OuterContainerStyles,
  Title,
  SearchContainer,
  ExistingText,
  SearchContainerTable,
} from "../../components/Layout/Typography";
import Heading from "../../components/Layout/Heading";
import { SERVICES } from "../../components/Layout/Services";
import fetchData from "../../components/Layout/FetchData";
import {
  del,
  post,
  get,
  put,
} from "../../components/Layout/ApiHandler/apihandler";
import EditModal from "../../components/Layout/Modal";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import EditIcon from "../../components/Svg/EditIcon";
import DeleteIcon from "../../components/Svg/DeleteIcon";
import Loader from "../../components/Loader/Loader";
import { AlertStatus } from "../../contants";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import NoData from "../../components/NoData";
import Alert from "../../components/Alert/Alert";

const DEFAULT_PAGE_SIZE = 10;

function BankDetails() {
  const TITLE = "Add Bank Details - BSG ContributionAdmin";
  const [searchText, setSearchText] = useState("");
  const [bankDetailsData, setBankDetailsData] = useState({});
  // const [individualBankData, setIndividualBankData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [currentPage, setCurrentPage] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [bankName, setBankName] = useState("");

  const handleAlertClose = () => {
    setOpenAlert(false);
  };
  const handleEdit = (event) => {
    setEdit(event.target.value);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getBankById = async (bankId) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankId}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setEdit(data.data.bankName);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleEditBank = async (bankId) => {
    setSelectedBankId(bankId);
    getBankById(bankId);
    setIsModalOpen(true);
  };
  const handleDeleteAlert = (bankId) => {
    setSelectedBankId(bankId);
    setOpenAlert(true);
  };

  const handleDeleteBank = async (bankId) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankId}`;
      const response = await del(url);
      if (response.ok) {
        toast.show("Bank Details Deleted Successfully", AlertStatus.SUCCESS);
        await fetchBankData();
        handleAlertClose();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleTotalElements = async () => {
    const url = `${SERVICES.BANKS_DETAILS}`;
    const response = await get(url);
    if (response.ok) {
      const data = await response.json();
      setTotalElements(data.data.totalElements);
    }
  };
  const fetchBankData = useCallback(async () => {
    const url = `${SERVICES.BANKS_DETAILS}?size=${DEFAULT_PAGE_SIZE}`;
    await fetchData(url, setBankDetailsData, setIsLoading);
  }, []);

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };

  // const handleSearch = async () => {
  //   console.log(searchText);
  //   if (searchText.trim() === "") {
  //     return;
  //   }
  //   try {
  //     const url = `${
  //       SERVICES.BANKS_DETAILS
  //     }/search?query=${searchText.toUpperCase()}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       if (data.data.content.length === 0) {
  //         toast.show("Bank not found", AlertStatus.ERROR);
  //       } else {
  //         setBankDetailsData(data.data);
  //       }
  //     } else {
  //       console.error("Failed to fetch city data");
  //     }
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };
  const handleSearch = async () => {
    // console.log(searchText);
    if (searchText.trim() === "") {
      fetchBankData();
      return;
    }
    try {
      const url = `${SERVICES.BANKS_DETAILS}?size=${totalElements}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const filteredData = data.data.content.filter((item) =>
          item.bankName.toLowerCase().includes(searchText.toLowerCase()),
        );
        if (filteredData.length === 0) {
          toast.show("Bank not found", AlertStatus.ERROR);
        } else {
          setBankDetailsData({ content: filteredData });
        }
      } else {
        console.error("Failed to fetch city data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleSubmit = async () => {
    // console.log(searchText);
    if (bankName.trim() === "") {
      return;
    }
    const url = SERVICES.BANKS_DETAILS;
    const data = {
      bankName: bankName.trim(),
    };

    try {
      const response = await post(url, data);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        await fetchBankData();
        toast.show("Bank Details Added Successfully", AlertStatus.SUCCESS);
        setBankName("");
      }
      if (response.status === 400) {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.SUCCESS);
      Sentry.captureException(error);
    }
  };

  const handleEditSubmit = async () => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${selectedBankId}`;
      const data = {
        bankName: edit.trim(),
      };

      const response = await put(url, data);

      if (response.ok) {
        toast.show("Bank Details Update Successfully", AlertStatus.SUCCESS);
        await fetchBankData();
        closeModal();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${SERVICES.BANKS_DETAILS}?page=${selectedPage}&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setBankDetailsData(data.data);
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBankData();
  }, [fetchBankData]);

  useEffect(() => {
    if (bankDetailsData.content) {
      const updatedTableData = bankDetailsData.content.map((item, index) => {
        const serialNumber = currentPage * DEFAULT_PAGE_SIZE + index + 1;
        return {
          id: item.id,
          column1: serialNumber,
          column2: item.bankName,
          column3: (
            <div
              style={{ display: "flex", gap: "25px", justifyContent: "center" }}
            >
              <EditIcon
                onClick={() => handleEditBank(item.id)}
                style={{ cursor: "pointer" }}
              />
              <DeleteIcon
                // onClick={() => handleDeleteBank(item.id)}
                onClick={() => handleDeleteAlert(item.id)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [bankDetailsData.content]);

  // useEffect(() => {
  //   if (individualBankData.length > 0) {
  //     const updatedTableData = individualBankData.map((item, index)=>{
  //       return {
  //         id: item.id,
  //         column1: index+1,
  //         column2: item.bankName,
  //         column3: (
  //           <>
  //           <Btn  onClick={() => handleEditBank(item.id)}>
  //             Edit
  //           </Btn>
  //           <Btn  onClick={() => handleDeleteBank(item.id)}>
  //             Delete
  //           </Btn>
  //         </>
  //         ),
  //       }
  //     });

  //     setTableData(updatedTableData);
  //   }
  // }, [individualBankData]);

  useEffect(() => {
    handleTotalElements();
  }, []);
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const tableHeaders = ["S. No.", "Bank Name", "Action"];
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Add Bank Details" />
      <OuterContainerStyles>
        <Title>Bank Details</Title>
        <SearchContainer>
          <InputField
            onChange={(e) => setBankName(e.target.value)}
            placeholder="Bank Name"
            customvalue={bankName}
          />
          <Button onClick={handleSubmit}>+ Add Bank</Button>
        </SearchContainer>
      </OuterContainerStyles>
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <ExistingText>Existing Bank (s)</ExistingText>
        <SearchContainerTable>
          <div style={{ width: "50%" }}>
            <InputField
              onChange={handleInputChange}
              placeholder="Search here..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </div>
          <Button onClick={handleSearch}>Search</Button>
          <Btn type="button" onClick={fetchBankData}>
            View All
          </Btn>
        </SearchContainerTable>
        {tableData?.length ? (
          <TableData
            tableData={tableData}
            data={bankDetailsData}
            headers={tableHeaders}
            onPageChange={handlePageChange}
          />
        ) : (
          !tableData?.length && isLoading === false && <NoData />
        )}
        {/* <DataTable data={tableData} headers={tableHeaders} /> */}
      </OuterContainerStyles>
      <EditModal
        isOpen={isModalOpen}
        handleClose={closeModal}
        onChange={handleEdit}
        handleSubmit={handleEditSubmit}
        heading="Edit Bank"
        placeholder="Enter Bank Name ..."
        initialValue={edit}
      />
      <Alert
        open={openAlert}
        onClose={handleAlertClose}
        onSubmit={() => handleDeleteBank(selectedBankId)}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default BankDetails;

const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;
